import { ProviderType } from 'features/connections'
import { MapDataset } from 'features/maps/types'
import { addGeomColumn, addJoinColumn, generateQuery, getNonDuplicatedColumns } from './utils'

export interface GenerateColumnsSourceQuery {
  sourceDataset: MapDataset & { fields; metadata }
  sourceColumn: string
  secondSourceDataset: MapDataset
  secondSourceColumn: string
  newTableSourceColumns?: Record<string, string>[]
  newTableSecondSourceColumns?: Record<string, string>[]
}
export function generateColumnsSourceQuery({
  sourceDataset,
  sourceColumn,
  secondSourceDataset,
  secondSourceColumn,
  newTableSourceColumns,
  newTableSecondSourceColumns
}: GenerateColumnsSourceQuery) {
  const columnsValueMain = newTableSourceColumns?.length
    ? newTableSourceColumns.map((column) => column.value)
    : sourceDataset.metadata.schema?.map((column) => column.name)

  addGeomColumn({ sourceDataset, columnsValueMain })
  addJoinColumn({ columnsValueMain, sourceColumn })
  const columnsSecondSource = getNonDuplicatedColumns({ newTableSecondSourceColumns, columnsValueMain })
  const payload = {
    mainColumns: columnsValueMain.map((c, i) => {
      if (i === 0) {
        return `base.${c}`
      } else {
        return `\t\tbase.${c}`
      }
    }),
    secondColumns: columnsSecondSource.map((c, i) => {
      if (i === 0) {
        return `second.${c}`
      } else {
        return `\t\tsecond.${c}`
      }
    }),
    base: sourceDataset,
    second: secondSourceDataset,
    joinBy: `base.${sourceColumn} = second.${secondSourceColumn}`
  }

  const connectionProvider = sourceDataset.providerId
  switch (connectionProvider) {
    case ProviderType.BIGQUERY:
      return generateQuery(payload)
    case ProviderType.SNOWFLAKE:
      return generateQuery(payload)
    case ProviderType.REDSHIFT:
      return generateQuery(payload)
    case ProviderType.POSTGRES:
      return generateQuery(payload)
    default:
      throw new Error(`Analysis not implemented for ${connectionProvider}`)
  }
}
